import React, { useCallback, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Survey } from 'survey-react-ui';
import { Model, StylesManager } from 'survey-core';
import Modal from './Modal';
import translate from '../translate';
import CloseIcon from '../icons/icon/CloseIcon';

function FormModal(props) {
  const { t, form, onClose, id, wrapperClass, showSave, isDisabled } = props;
  const { formQuestionData, formAnswerData, productId } = form;

  // Make sure that it's only shown if the React side is rendered
  const [showSurveyJS, setShowSurveyJS] = useState(false);
  const [surveyData, setSurveyData] = useState({});
  const [isCompleted, setIsCompleted] = useState(false);
  const [answers, setAnswers] = useState(formAnswerData || null);

  // Handle completion of survey
  const alertResults = useCallback(sender => {
    setAnswers(sender.data);
    setIsCompleted(true);
  }, []);

  useEffect(() => {
    const formData = formQuestionData;
    // Apply the theme
    StylesManager.applyTheme('modern');

    // Disable all questions if isDisabled is true
    if (isDisabled) {
      formData.mode = 'display';
    }

    // Make sure that it's only shown if the React side is rendered
    setShowSurveyJS(true);
    // Update the survey state to the correct data
    setSurveyData(new Model(formData));
  }, []);

  // If survey is well rendered it should have the onComplete param
  // if so, added the function to handle data after survey is finished
  if (surveyData.onComplete) {
    surveyData.onComplete.add(alertResults);
  }

  const handleSave = () => {
    onClose(productId, answers);
  };

  return (
    <Modal onClose={onClose} id={id}>
      <div
        className={`modal-dialog modal-dialog-centered modal-lg ${wrapperClass}`}
        role="document"
      >
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">{t('form.preview')}</h5>
            <button type="button" onClick={onClose}>
              <CloseIcon />
            </button>
          </div>
          {showSurveyJS ? <Survey model={surveyData} data={answers} /> : null}
          {showSave && isCompleted ? (
            <div className="save-container">
              <button
                className="btn btn-dynamic save-survey-form"
                type="button"
                onClick={handleSave}
              >
                {t('save_btn')}
              </button>
            </div>
          ) : null}
        </div>
      </div>
    </Modal>
  );
}

FormModal.propTypes = {
  t: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
  id: PropTypes.string,
  isDisabled: PropTypes.bool,
  wrapperClass: PropTypes.string,
  form: PropTypes.shape({
    formQuestionData: PropTypes.shape({}),
    formAnswerData: PropTypes.shape({}),
    productId: PropTypes.string,
  }).isRequired,
  showSave: PropTypes.bool,
};

FormModal.defaultProps = {
  id: 'formModal',
  wrapperClass: '',
  showSave: true,
  isDisabled: false,
};

export default translate(FormModal);
